<template>
  <div class="bank">
    <Step :arr="stepProcess" />
    <Bar :text="$route.meta.name" />
    <div class="bank-form">
      <keep-alive>
        <router-view ref="cForm"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import Step from '@/components/CA/Step'
import Bar from '@/components/Bar/bar'
import { queryOrderDetail, queryOrderByOuterOrderNo } from '@/api/order'
import store from './mixins/store'

const stepProcess = [
  { icon: 1, span: '信息填写', status: 'finish', time: '' },
  { icon: 2, span: '支付', status: 'wait', time: '' },
  { icon: 3, span: '审核', status: 'wait', time: '' },
  { icon: 4, span: '出函', status: 'wait', time: '' },
]

export default {
  name: 'AnhuiBank',
  components: {
    Step,
    Bar,
  },
  mixins: [store],
  data() {
    return {
      stepProcess,
    }
  },
  beforeMount() {
    const { edit } = this
    const { orderID, outerOrderNo } = this.$route.query

    if (
      (orderID && orderID === edit?.id) ||
      (outerOrderNo && outerOrderNo === edit?.id)
    ) {
      return
    }
    const cb = (v) => {
      this.clear()
      if (!v.data) return
      if (this.setDdit && typeof this.setDdit === 'function') {
        this.setDdit(orderID || outerOrderNo)
      }
      if (v.data.model?.apiName) {
        v.data = v.data.model
      }
      v.data.web_type = v.data.isExectronic==='1'?'electron':'paper'
      this.guarantee(v.data)

      // Active rendering when asynchronous
      // You can also use watch and computed attributes
      this.$refs.cForm.init(v.data)
    }

    if (orderID) {
      queryOrderDetail(orderID).then(cb)
    }
    if (outerOrderNo) {
      queryOrderByOuterOrderNo(outerOrderNo).then(cb)
    }
  },
}
</script>

<style lang="scss" scoped>
.bank {
  &-form {
    width: 600px;
    margin: 10px auto;
  }
}
</style>
